module.exports = {
  "level1": {
    "name": "ชื่อจริง",
    "address": "ที่อยู่ปัจจุบัน",
    "bank_number": "บัญชีธนาคาร",
    "wc": "ตกลง",
    "name_nodata": "ชื่อต้องไม่เว้นว่าง",
    "id_card_nodata": "หมายเลขประจำตัวประชาชนต้องไม่เว้นว่าง",
    "address_nodata": "ที่อยู่ต้องไม่เว้นว่าง",
    "bank_number_nodata": "บัญชีธนาคารต้องไม่เว้นว่าง",
    "input-username": "กรุณาใส่ชื่อจริงของท่าน",
    "zjhm": "หมายเลขประจำตัวประชาชน",
    "input-idcard": "โปรดใส่หมายเลขประจำตัวประชาชน",
    "input-address": "โปรดใส่ที่อยู่",
    "zjlx": "ประเภทบัตร",
    "qxzzjlx": "โปรดเลือกประเภทบัตร",
    "sfz": "บัตรประจำตัวประชาชน",
    "hz": "หนังสือเดินทาง",
    "jsz": "ใบขับขี่",
    "khh": "ธนาคารบัญชี",
    "qsrkhh": "กรุณากรอกธนาคาร",
    "yhkh": "บัญชีธนาคาร",
    "qsryhkh": "กรุณาใส่เลขบัญชีธนาคาร",
    "gjlb": "รายการประเทศ",
    "qxzgjlb": "กรุณาเลือกประเทศ / ภูมิภาค"
  },
  "my": {
    "mqrcode": "รหัสคิวอา ของฉัน",
    "as": "ตั้งค่า",
    "pc": "การรับรองระดับเบื้องต้น",
    "ac": "ใบรับรองระดับอาวุโส",
    "ms": "แบ่งปัน",
    "me": "รายได้ของฉัน",
    "zsr": "รายได้รวม",
    "mp": "โปรโมชั่นของฉัน",
    "yqhy": "เชิญเพื่อน",
    "ar": "บันทึกบัญชี",
    "hc": "ศูนย์ช่วยเหลือ",
    "nodata": "ไม่มีข้อมูล",
    "med": "รายละเอียดรายได้",
    "aes": "รายได้สะสม (USDT)",
    "one": "รุ่นที่หนึ่ง",
    "two": "รุ่นที่สอง",
    "three": "รุ่นที่สาม",
    "four": "รุ่นที่สี่",
    "ones": "จำนวนรุ่นที่หนึ่ง",
    "twos": "จำนวนรุ่นที่สอง",
    "threes": "จำนวนรุ่นที่สาม",
    "fours": "จำนวนรุ่นที่สี่",
    "promotion": "จำนวนโปรโมชั่น",
    "customers": "รายได้ของฉัน",
    "wdzc": "ทรัพย์สินของฉัน",
    "wdzc1": "ทรัพย์สินของฉัน",
    "wyfx": "แบ่งปัน",
    "wdsy": "รายได้ของฉัน",
    "wdtg": "โปรโมชั่นของฉัน",
    "zhjl": "บันทึกบัญชี",
    "zxkf": "ติดต่อเรา",
    "wdxx": "ข้อความของฉัน",
    "smrz":"การรับรองความถูกต้อง KYC",
    "sfyz":"การรับรองความถูกต้อง KYC"
  },
  "footer": {
    "home": "หน้าแรก",
    "quotation": "ตลาด",
    "currency": "ธุรกรรมสกุลเงิน",
    "lever": "สัญญา",
    "my": "บัญชีผู้ใช้",
    "lc": "ถือเงินเพื่อรับดอกเบี้ย"
  },
  "index": {
    "wdzc": "สินทรัพย์ของฉัน (USDT)",
    "dl": "เข้าสู่ระบบ",
    "zxkf": "ติดต่อเรา",
    "increase": "กระดานเคลื่อนไหว",
    "usercenter": "ศูนย์ส่วนบุคคล",
    "security": "ศูนย์รักษาความปลอดภัย",
    "address": "ที่อยู่การถอน",
    "aboutus": "เกี่ยวกับเรา",
    "vol": "ปริมาณ 24H",
    "kjcb": "ฝากเงิน",
    "zcbz": "BTC, USDT...",
    "logout":"ออกจากระบบ",
    "language":"ภาษา"
  },
  "transaction": {
    "buy": "ซื้อเข้า",
    "sell": "ขายออก",
    "pwd": "รหัสผ่านการทำธุรกรรม",
    "inputnum": "ปริมาณนำเข้า",
    "limit": "ขีดจำกัด",
    "avaiable": "ใช้ได้",
    "turnover": "ยอดที่ทำรายการ",
    "handicap": "แฮนดิแคป",
    "number": "ปริมาณ",
    "nonumber": "ปริมาณที่ไม่สำเร้จ",
    "numbered": "ปริมาณที่สำเร้จ",
    "price": "ราคา",
    "marketprice": "ราคาตลาด",
    "cancel": "ยกเลิก",
    "time": "เวลา",
    "nomore": "หมดชั่วคราว",
    "nodata": "ไม่มีบันทึก",
    "getmore": "โหลดเพิ่ม",
    "mycommission": "คำสั่งซื้อของฉัน",
    "currentbuy": "คำสั่งซื้อปัจจุบัน (ซื้อเข้า)",
    "currentsell": "คำสั่งซื้อปัจจุบัน (ขายออก)",
    "his": "คำสั่งซื้อในอดีต (สำเร็จ)",
    "currency": "สกุลเงิน",
    "option": "ดำเนินการ",
    "wtime": "หมดเวลา",
    "wnumber": "จำนวนเงินที่สำเร็จ",
    "wprice": "ราคาเต็ม"
  },
  "mk": {
    "high": "สูง",
    "low": "ต่ำ",
    "vol": "ปริมาณ 24H",
    "newPrice": "ราคาล่าสุด",
    "product": "สินค้า",
    "name":"ชื่อ",
    "rank": "กระดานเคลื่อนไหว"
  },
  "deals": {
    "issue_time": "เวลาเปิดขาย",
    "issue_number": "จำนวนเปิดขาย",
    "white_book": "กระดาษสีขาว",
    "weburl": "เว็บไซต์อย่างเป็นทางการ",
    "video_url": "วีดีโอแนะนำ",
    "introduction": "บทนำ",
    "onhand": "1 ล็อต เท่ากับ",
    "position": "ยอดที่ถือปัจจุบัน",
    "leverorder": "คำสั่งเลเวอเรจ",
    "leverposition": "ยอดเลเวอเรจ",
    "inputprice": "ใส่ราคา",
    "inputmul": "ใส่เท่าตัว",
    "selectmul": "เลือกเท่าตัว",
    "onehand": "1 ล็อต เท่ากับ",
    "hand": "ล็อตการซื้อขาย",
    "marketval": "มูลค่าตลาดตามสัญญา",
    "bond": "เงินประกัน",
    "balance": "คงเหลือ",
    "type": "ประเภท",
    "risk": "อัตราความเสี่ยง",
    "total": "กำไรและขาดทุนของยอดที่ถือทั้งหมด:",
    "onekey": "ชำระบัญชีคลิกเดียว",
    "makemore": "(ยาวไป)",
    "makeless": "(สั้น)",
    "current": "คำสั่งซื้อปัจจุบัน",
    "all": "ทั้งหมด",
    "weing": "คำสั่งที่เปิดอยู่",
    "tding": "กำลังดำเนินการ",
    "ping": "กำลังคัทลอส ",
    "pied": "คัทลอสแล้ว",
    "ceiled": "ยกเลิกคำสั่งซื้อ",
    "weprice": "ค่าธรรมเนียม",
    "oprice": "ราคาเปิด",
    "nowprice": "ราคาปัจจุบัน",
    "zyprice": "ขายทำกำไร",
    "zsprice": "ราคาคัทลอส",
    "canbond": "ยอดที่สามารถใช้ได้",
    "optime": "เวลาเปิด",
    "pgtime": "เวลาปิด",
    "znum": "ปริมาณที่แปลงแล้ว",
    "gprice": "ค่าธรรมเนียมค้างคืน",
    "pcang": "คัทลอส ",
    "revoke": "ยกเลิกคำสั่งซื้อ",
    "fee": "ค่าธรรมเนียม",
    "you": "ซื้อขายในราคาที่ดีที่สุดในปัจจุบัน"
  },
  "assets": {
    "copy": "คัดลอก",
    "avaiable": "ใช้ได้",
    "lock": "ถูกล็อก",
    "conversion": "แลกเปลี่ยน",
    "exact": "บัญชีซื้อขายหลักทรัพย์",
    "num": "ปริมาณ",
    "time": "เวลา",
    "all": "ทั้งหมด",
    "canuse": "ใช้ได้",
    "cmoney": "ฝากเงิน",
    "tmoney": "ถอนเงิน",
    "caddress": "ที่อยู่เงินฝาก",
    "copyaddress": "คัดลอกที่อยู่",
    "taddress": "ที่อยู่การถอน",
    "taddressm": "กรุณากรอกที่อยู่ถอนเงิน",
    "rate": "ค่าธรรมเนียม",
    "dnum": "ยอดที่เข้าบัญชี",
    "more": "โหลดเพิ่ม",
    "nodata": "ไม่มีบันทึก",
    "yczc": "ซ่อนยอดคงเหลือที่เป็น0",
    "total":"การแปลงสินทรัพย์ (USDT)"
  },
  "td": {
    "drecord": "บันทึกคำสั่งซื้อ",
    "orecord": "บันทึกคำสั่งซื้อที่สำเร็จ",
    "filter": "กรอง",
    "dstatus": "สถานะคำสั่งซื้อ",
    "nofinish": "ยังไม่สำเร็จ",
    "finished": "สำเร็จ",
    "ceiled": "ยกเลิก",
    "reset": "รีเซ็ต",
    "confirm": "ตกลง",
    "time": "เวลา",
    "num": "ปริมาณ",
    "price": "ราคา",
    "ptime": "เวลาคำสั่งซื้อ",
    "receiver": "ผู้รับเงิน",
    "open": "ธนาคารบัญชี",
    "pwd": "รหัสผ่านการทำธุรกรรม",
    "ppwd": "โปรดใส่รหัสผ่านการทำธุรกรรม",
    "sure": "ตกลง",
    "realName": "ชื่อจริง",
    "pnum": "โปรดใส่จำนวน",
    "buyNum": "ปริมาณซื้อ",
    "currency": "สกุลเงิน"
  },
  "fat": {
    "ceil": "ยกเลิก",
    "num": "ปริมาณ",
    "submit": "สั่งซื้อ",
    "pwd": "รหัสผ่านการทำธุรกรรม",
    "ppwd": "โปรดใส่รหัสผ่านการทำธุรกรรม",
    "sure": "ยืนยันสั่งซื้อ",
    "auHigh": "ใบรับรองระดับอาวุโส"
  },
  "auth": {
    "bh": "ปฏิเสธ",
    "mycenter": "ศูนย์ส่วนบุคคล",
    "test": "ยืนยันตัวตน",
    "testing": "กำลังตรวจสอบ",
    "name": "ชื่อ",
    "account": "บัญชีผู้ใช้",
    "id_card_face": "โปรดอัพโหลดด้านหน้าของบัตรประชาชน",
    "id_card_back": "โปรดอัพโหลดด้านหลังของบัตรประชาชน",
    "updata": "ส่ง",
    "updata_again": "ส่งใหม่"
  },
  "code": {
    "notice": "ประกาศ"
  },
  "safe": {
    "title": "ความปลอดภัยของบัญชี",
    "center": "ศูนย์รักษาความปลอดภัย",
    "yysz": "ตั้งค่าภาษา",
    "ssms": "โหมดมืด",
    "gywm": "เกี่ยวกับเรา",
    "lgpwd": "ใส่รหัสผ่าน",
    "resetpwd": "เปลี่ยนรหัสผ่าน",
    "paccount": "โปรดใส่หมายเลขโทรศัพท์หรืออีเมล",
    "reset": "แก้ไข",
    "ceil": "ยกเลิก",
    "pcode": "รหัสยืนยัน",
    "sure": "ยืนยัน",
    "newPwd": "รีเซ็ตรหัสผ่าน",
    "ppwd": "โปรดใส่รหัสผ่าน",
    "reppwd": "โปรดใส่รหัสผ่านอีกครั้ง",
    "repwd": "รีเซ็ตรหัสผ่าน",
    "zpwd": "รหัสผ่านการทำธุรกรรม"
  },
  "met": {
    "open": "ชื่อธนาคาร",
    "bank": "บัญชีธนาคาร",
    "realname": "ชื่อจริง",
    "save": "บันทึก",
    "popen": "โปรดใส่ชื่อธนาคาร",
    "pbank": "โปรดใส่เลขที่บัญชี",
    "pname": "กรุณาใส่ชื่อจริงของท่าน"
  },
  "ads": {
    "tas": "ที่อยู่การถอน",
    "address": "ที่อยู่",
    "noads": "คุณไม่มีที่อยู่",
    "adds": "ที่อยู่",
    "remark": "หมายเหตุ",
    "cel": "ลบ"
  },
  "jc": {
    "ppwd": "โปรดใส่รหัสผ่าน"
  },
  "lg": {
    "welcome": "สวัสดี! ต้อนรับเข้าสู่ระบบ",
    "lgtel": "เข้าสู่ระบบบนมือถือ",
    "lgeml": "เข้าสู่ระบบด้วยอีเมล",
    "paccount": "เบอร์โทรศัพท์ หรือ E-mail",
    "ppwd": "โปรดใส่รหัสผ่าน",
    "ppwd2": "โปรดยืนยันรหัสผ่าน",
    "pcode": "รหัสยืนยัน",
    "qsryqm": "โปรดใส่รหัสเชิญ",
    "noaccount": "ยังไม่มีบัญชี",
    "register": "ลงทะเบียน",
    "phregister": "ลงทะเบียนโดยโทรศัพท์",
    "emregister": "ลงทะเบียนโดยอีเมล",
    "pphone": "เบอร์โทรศัพท์",
    "ceil": "ยกเลิก",
    "send": "รับรหัสยืนยัน",
    "sure": "ตกลง",
    "email": "โปรดใส่อีเมล",
    "emtest": "ยืนยันอีเมล",
    "pemcode": "รหัสยืนยัน",
    "ppcode": "โปรดใส่รหัสยืนยันทางโทรศัพท์",
    "ftpwd": "ลืมรหัสผ่าน",
    "ptext": "โปรดใส่หมายเลขโทรศัพท์หรืออีเมล",
    "yzm": "รหัสยืนยัน",
    "mm": "รหัสผ่าน",
    "qrmm": "ยืนยันรหัสผ่าน",
    "language":"ภาษา",
    "qregister":"ลงทะเบียน",
    "lgs":"เข้าสู่ระบบ",
    "ftpwds":"ลืมรหัสผ่าน",
    "kjzc": "ติดต่อเราเพื่อลงทะเบียนด่วน",
    "kjzc1": "ไม่สามารถรับแคปต์ชา?",
    "kjzc2": "ลงทะเบียนด่วน",
    "wyzx": "ฉันรู้แล้ว",
    "qtxyxzh": "สำคัญ: โปรดกรอกที่อยู่อีเมลหรือหมายเลขโทรศัพท์มือถือที่ถูกต้อง ซึ่งสามารถใช้เพื่อเรียกรหัสผ่านของคุณ",
    "next": "ขั้นตอนต่อไป"
  },
  "gjrz": {
    "title": "ใบรับรองระดับอาวุโส",
    "t1": "1. รองรับรูปภาพ JPG, JPEG หรือ PNG น้อยกว่า 8M",
    "t2": "2. ภาพถ่ายบัตรต้องชัดเจนและไม่อนุญาตให้มีการดัดแปลงหรือมีสิ่งปกปิด ต้องเห็นรูปหน้า เลขบัตรและสกุลชัดเจน ",
    "t3": "3. รูปถ่ายต้องไม่สวมหมวก แนะนำไม่ให้ผู้ถือบัตรแต่งหน้า มองเห็นใบหน้าที่ชัดเจนและเห็นไหล่สองข้าง",
    "t4": "ตกลง",
    "bh": "ปฏิเสธ",
    "shz": "กำลังตรวจสอบ",
    "shtg": "ผ่านการตรวจสอบ",
    "sczjz": "อัพโหลดรูปบัตรประชาชน",
    "sczjzmz": "โปรดอัพโหลดด้านหน้าของบัตรประชาชน",
    "sczjbmz": "โปรดอัพโหลดด้านหลังของบัตรประชาชน",
    "scgrqmz": "โปรดอัพบัตรประชาชนและลายเซ็น"
  },
  "chongzhi": {
    "title": "ฝากเงิน",
    "cbjl": "บันทึกการฝาก",
    "t1": "ปริมาณ",
    "t2": "โปรดใส่จำนวน",
    "t3": "บรรยาย(ไม่จำเป็น)",
    "t4": "โปรดใส่คำอธิบาย",
    "t5": "รูปภาพคูปอง",
    "t6": "ตกลง",
    "t7": "ชื่อลูกโซ่",
    "t8": "รหัสคิวอาร์",
    "t9": "บันทึกรหัสคิวอาร์",
    "t10": "ที่อยู่เงินฝาก",
    "t11": "คัดลอก",
    "zy": "สำคัญ",
    "tips1": "โปรดอย่าเติมสินทรัพย์ใด ๆ ที่ไม่ได้อยู่ในสกุลเงินนี้ไปยังที่อยู่ด้านบน มิฉะนั้นจะไม่สามารถเรียกสินทรัพย์กลับมาได้",
    "tips2": "1. ความเข้ากันได้กับกระเป๋าเงิน/แพลตฟอร์ม: นั่นคือ เครือข่ายได้รับการสนับสนุน หากแพลตฟอร์มเป้าหมายไม่สนับสนุนเครือข่ายการถอนเงินของคุณ สินทรัพย์จะไม่สามารถเรียกคืนได้",
    "tips3": "2. เครือข่ายเติมเงินและแพลตฟอร์มเป้าหมายเหมือนกัน หากคุณเลือกที่อยู่เป้าหมายคือเครือข่าย Ethereum แต่การเติมเงินเลือกสมาร์ทเชน TRC20 คุณอาจไม่สามารถเรียกข้อมูลสินทรัพย์ดิจิทัลของคุณได้",
    "tips4": "3. ตรวจสอบให้แน่ใจว่าที่อยู่และจำนวนเงินของคุณถูกต้องก่อนทำการชาร์จ",
    "tips5": "คำเตือน: เนื่องจากการไม่เปิดเผยตัวตนและความเป็นส่วนตัวของเครือข่ายที่ถูกบล็อก เมื่อคุณป้อนข้อมูลผิด คุณจะสูญเสียทรัพย์สินที่เกี่ยวข้อง โปรดตรวจสอบที่อยู่และปริมาณการเติมเงินของคุณอย่างระมัดระวัง"
  },
  "tibi": {
    "title": "ถอน",
    "tbjl": "บันทึกการถอน",
    "t1": "ที่อยู่การถอน",
    "t2": "กรุณากรอกที่อยู่ถอนเงิน",
    "t3": "จำนวนการถอน",
    "qsrtbsl": "โปรดใส่จำนวนการถอน",
    "t4": "ถอนขั้นต่ำ",
    "t5": "รหัสผ่านการทำธุรกรรม",
    "t6": "โปรดใส่รหัสผ่านการทำธุรกรรม",
    "t7": "ค่าธรรมเนียม",
    "t8": "ยอดที่เข้าบัญชี",
    "t9": "ตกลง",
    "sc": "ลบ",
    "bj": "แก้ไข",
    "bq": "ป้ายกำกับ (บันทึก)",
    "qsrbq": "กรุณาใส่ป้ายกำกับ",
    "yhktx": "ถอนบัตรธนาคาร",
    "yhmc": "ชื่อธนาคาร",
    "qsryhmc": "โปรดใส่ชื่อธนาคาร",
    "yhzh": "บัญชีธนาคาร",
    "qsryhzh": "โปรดใส่เลขบัญชีธนาคาร",
    "gjhkdm": "รหัสโอนเงินระหว่างประเทศ",
    "qsrgjhkdm": "โปรดใส่รหัสโอนเงินระหว่างประเทศ",
    "yhdz": "ที่อยู่ธนาคาร",
    "qsryhdz": "โปรดใส่ที่อยู่ธนาคาร",
    "skrxm": "ชื่อผู้รับเงิน",
    "qsrskrxm": "โปรดใส่ชื่อผู้รับเงิน",
    "skrdh": "โทรศัพท์ผู้รับเงิน",
    "qsrskrdh": "โปรดใส่หมายเลขโทรศัพท์ผู้รับเงิน",
    "skrdz": "ที่อยู่ผู้รับเงิน",
    "qsrskrdz": "โปรดใส่ที่อยู่ผู้รับเงิน"
  },
  "huazhuan": {
    "t4": "โปรดใส่จำนวน",
    "ky": "ใช้ได้",
    "t10": "ตกลง"
  },
  "banner": {
    "title": "รายละเอียด"
  },
  "download": {
    "t1": "การทำธุรกรรมทุกที่",
    "xz": "ดาวน์โหลด"
  },
  "xgdlmm": {
    "title": "แก้ไขรหัสผ่านเข้าสู่ระบบ",
    "zh": "บัญชี",
    "yzm": "รหัสยืนยัน",
    "yzmts": "รหัสยืนยัน",
    "hqyzm": "รับรหัสยืนยัน",
    "mm": "รหัสผ่าน",
    "qrmm": "ยืนยันรหัสผ่าน",
    "qr": "ยืนยัน",
    "zhts":"โทรศัพท์มือถือหรืออีเมล",
    "mmts":"รหัสผ่านประกอบด้วยตัวอักษรและตัวเลขความยาว 6-12 หลัก"
  },
  "sztkmm": {
    "title": "ตั้งรหัสผ่านการทำธุรกรรม",
    "dlmm": "ใส่รหัสผ่าน",
    "dlmmts": "โปรดใส่รหัสผ่านของคุณ",
    "xmm": "รหัสผ่านใหม่",
    "mmts": "ความยาวรหัสผ่าน 6 หลัก",
    "qrmm": "ยืนยันรหัสผ่าน",
    "qr": "ยืนยัน",
    "qd": "ตกลง",
    "sztkts": "เคล็ดลับ: โปรดไปตั้งรหัสผ่านการทำธุรกรรมที่ศูนย์ความปลอดภัย"
  },
  "rule": {
    "title": "กติกากิจกรรม",
    "title2": "กติกา",
    "title3": "กิจกรรม"
  },
  "news": {
    "title": "ข้อความของฉัน",
    "ckxq": "ดูรายละเอียด",
    "gg": "ประกาศ"
  },
  "search": {
    "qx": "ยกเลิก"
  },
  "wdtg": {
    "wdyqlj": "ลิงค์คำเชิญของฉัน",
    "wdyqm": "รหัสคำเชิญของฉัน",
    "schbyq": "สร้างคำเชิญโปสเตอร์",
    "ljtgsy": "รายได้จากโปรโมชั่นสะสม",
    "tkrs": "จำนวนคำเชิญ",
    "ljyj": "คอมมิชชั่นสะสม",
    "yjmx": "รายละเอียดค่าคอมมิชชั่น",
    "ljyjjl": "รางวัลคอมมิชชั่นสะสม (usdt)",
    "ljsy": "รายได้สะสม",
    "ljyqjl": "รางวัลคำเชิญสะสม (usdt)",
    "fxd": "แชร์ไปยัง",
    "bctp": "บันทึกภาพ",
    "qx": "ยกเลิก",
    "t3": "กดภาพค้างไว้เพื่อจดจำ หรือสแกน"
  },
  "bzhl": {
    "title": "AI รับเหรียญ",
    "gz": "กติกา",
    "tgdd": "คำสั่งเอสโครว์",
    "zztgdzj": "กองทุนภายใต้การดูแล",
    "yjjrsy": "รายได้วันนี้",
    "ljsy": "รายได้สะสม",
    "tgzdd": "คำสั่งที่รอดำเนินการ",
    "cljxcp": "ผลิตภัณฑ์เชิงกลยุทธ์",
    "dbxe": "จำกัดยอดเดียว",
    "rsyl": "อัตราผลตอบแทนรายวัน",
    "zq": "รายสัปดาห์",
    "qmr": "ซื้อทันที",
    "bbzhzc": "ทรัพย์สินทางบัญชี",
    "dd": "คำสั่ง",
    "buy": "ซื้อเข้า",
    "jxcp": "สินค้าแนะนำ",
    "ckdd": "ตรวจสอบคำสั่งซื้อ",
    "gd": "มากกว่า",
    "xzbzts": "ง่ายและปลอดภัย สามารถเลือกเงินปันผลได้หลายสกุลเงิน",
    "qtbz": "เหรียญอื่นๆ"
  },
  "bzhlgm": {
    "qtzq": "USDT รอบ 7 วัน",
    "rsyl": "อัตราผลตอบแทนรายวัน (%)",
    "lczq": "การเงินรายสัปดาห์",
    "dbxe": "จำกัดยอดเดียว",
    "pxsj": "เวลาปันผล",
    "mr": "ทุกวัน",
    "dqfh": "ผลตอบแทนเมื่อครบกำหนด",
    "tgzj": "ทุนการดูแล",
    "tqsh": "รับการไถ่ถอน",
    "yjsy": "ผลตอบแทนโดยประมาณ (USDT)",
    "kyzc": "สินทรัพย์ที่มีอยู่ (USDT)",
    "cpjs": "รายละเอียดสินค้า",
    "tgje": "ยอดเงินการดูแล",
    "qsrtgje": "โปรดใส่ยอดเงินการดูแล",
    "qb": "ทั้งหมด",
    "rm": "ซื้อทันที",
    "cpzq": "อายุผลิตภัณฑ์",
    "gz": "เข้าใจกฎและสิทธิ์"
  },
  "bzhlwdtg": {
    "title": "สถานะคำสั่งซื้อ",
    "tgz": "ระหว่าการดูแล",
    "ywc": "สำเร็จ",
    "ysh": "ถอนคืนแล้ว",
    "tgje": "ยอดเงินการดูแล/จำนวนวันรอบสัปดาห์",
    "rsyl": "อัตราผลตอบแทนรายวัน",
    "yhl": "กำไร/วันคงเหลือ",
    "xdsj": "เวลาคำสั่งซื้อ",
    "sh": "การไถ่ถอน",
    "ddxq": "รายละเอียดคำสั่งซื้อ",
    "ddh": "เลขที่ใบสั่งซื้อ"
  },
  "bzjj": {
    "t1": "สร้างรายได้ทุกวัน",
    "cpld": "จุดเด่นของผลิตภัณฑ์",
    "scsq": "ฝากและรับได้ตลอดเวลา",
    "pxzq": "รอบการจ่ายเงินปันผล",
    "mtxf": "ออกทุกวัน",
    "hqlx": "ดอกเบี้ยออมทรัพย์",
    "zj": "ทุน 100%",
    "aqbz": "ความปลอดภัย",
    "jjrsy": "รายได้วันหยุด",
    "sybjd": "รายได้ไม่ขาดตอน",
    "bjd": "ไม่ขาดตอน",
    "cgcrh": "หลังฝากสำเร็จ",
    "dtqx": "วันหยุด",
    "jglz": "ตัวอย่างเช่น",
    "syjs": "การคำนวณรายได้",
    "cont2": "ขั้นต่ำ: 10000U× 0.3%-30U",
    "cont3": "สูงสุด: 10000U× 0.5%-50U",
    "gywyj": "เกี่ยวกับค่าผิดสัญญา",
    "wycy": "อยากมีส่วนร่วม"
  },
  "zyzs": {
    "title": "ทำกำไร และหยุดการสูญเสีย",
    "zy": "ทำกำไร",
    "zs": "หยุดการสูญเสีย",
    "qsrzyjg": "โปรดใส่ราคาทำกำไร",
    "qsrzsjg": "โปรดใส่ราคาหยุดการสูญเสีย",
    "scjg": "ราคาตลาด",
    "wxts": "เคล็ดลับ:",
    "qr": "ยืนยัน"
  },
  "bbjy": {
    "mr": "ซื้อเข้า",
    "mc": "ขายออก",
    "mai": "ซื้อ",
    "sell": "ขาย",
    "xj": "ขีดจำกัด",
    "sj": "ราคาตลาด",
    "pk": "แฮนดิแคป",
    "jg": "ราคา",
    "sl": "ปริมาณ",
    "mrl": "ยอดซื้อเข้า",
    "ss": "ปริมาณ",
    "mcl": "ปริมาณขายออก",
    "ky": "ใช้ได้",
    "km": "ซื้อได้",
    "ksell": "พร้อมขาย",
    "jye": "ยอดที่ทำรายการ",
    "dqwt": "คำสั่งซื้อปัจจุบัน",
    "lswt": "ค่าคอมมิชชั่นอดีต",
    "jj": "บทนำ",
    "wtzl": "รวม",
    "wtjg": "ราคาคอมมิชชั่น",
    "ycjl": "ปริมาณ",
    "cjjj": "ราคาซื้อขายเฉลี่ย",
    "cd": "ยกเลิกคำสั่งซื้อ",
    "xd": "สั่งซื้อ",
    "ywc": "สำเร็จ",
    "ycd": "ยกเลิกคำสั่งซื้อ",
    "wqcj": "เสร็จสมบูรณ์",
    "zx": "เลือกเอง",
    "scjg": "ราคาตลาด",
    "fhsj": "เวลาเปิดขาย",
    "fhsl": "จำนวนเปิดขาย",
    "bps": "กระดาษสีขาว",
    "gw": "เว็บไซต์อย่างเป็นทางการ",
    "qx": "ยกเลิก"
  },
  "hyjy": {
    "mai": "ซื้อ",
    "sell": "ขาย",
    "kc": "เปิดการขาย",
    "pc": "คัทลอส ",
    "cc": "ถือเหรียญ",
    "kp": "ปิด",
    "kpc": "ปิดระยะสั้น",
    "kcc": "ตำแหน่งที่ถือได้",
    "kkd": "เปิดระยะยาว",
    "kpd": "ปิดระยะยาว",
    "kkk": "เปิดสั้น",
    "xj": "ขีดจำกัด",
    "sj": "ราคาตลาด",
    "xjwt": "จำกัดคำสั่งซื้อ",
    "sjwt": "คำสั่งของตลาด",
    "pk": "แฮนดิแคป",
    "jg": "ราคา",
    "sl": "ปริมาณ",
    "gg": "เลเวอเรจ",
    "tzgg": "ปรับเลเวอเรจ",
    "ggbs": "เลเวอเรจเท่าตัว",
    "mrl": "ยอดซื้อเข้า",
    "ky": "ใช้ได้",
    "jye": "ยอดที่ทำรายการ",
    "dqwt": "คำสั่งซื้อปัจจุบัน",
    "lswt": "ค่าคอมมิชชั่นอดีต",
    "ptwt": "คำสั่งซื้อทั่วไป",
    "dqwtmr": "คำสั่งซื้อปัจจุบัน (ซื้อเข้า)",
    "dqwtmc": "คำสั่งซื้อปัจจุบัน (ขายออก)",
    "hywt": "สัญญาคำสั่งซื้อ",
    "jj": "บทนำ",
    "wtzl": "รวม",
    "wtjg": "ราคาคอมมิชชั่น",
    "ycjl": "ปริมาณ",
    "cjjj": "ราคาซื้อขายเฉลี่ย",
    "cd": "ยกเลิกคำสั่งซื้อ",
    "xd": "สั่งซื้อ",
    "wqcj": "เสร็จสมบูรณ์",
    "ywc": "สำเร็จ",
    "ycd": "ยกเลิกคำสั่งซื้อ",
    "zx": "เลือกเอง",
    "scjg": "ราคาตลาด",
    "fhsj": "เวลาเปิดขาย",
    "fhsl": "จำนวนเปิดขาย",
    "bps": "กระดาษสีขาว",
    "gw": "เว็บไซต์อย่างเป็นทางการ",
    "mrzd": "ซื้อนาน",
    "mrpk": "ซื้อสั้น",
    "mczk": "ขายระยะสั้น",
    "mcpd": "ขายระยะยาว",
    "mrkdkz": "ซื้อเปิดยาว (ขาขึ้น)",
    "mrpkkz": "ซื้อชอร์ต (ขาขึ้น)",
    "mckkkd": "ขาย open short (ขาลง)",
    "mcpdkd": "ขายทรงตัวยาว (ขาลง)",
    "yxhy": "สัญญาถาวร",
    "dc": "หลายตำแหน่ง",
    "syl": "อัตราผลตอบแทน",
    "bzjl": "อัตราเงินประกัน",
    "tzbzj": "ปรับเงินประกัน",
    "zyzs": "ทำกำไร และหยุดการสูญเสีย",
    "zhang": "ปริมาณ",
    "qblx": "ทุกประเภท",
    "qb": "ทั้งหมด",
    "ccjg": "ราคาตำแหน่ง",
    "ccsl": "จำนวนตำแหน่ง",
    "yk": "กำไรขาดทุน",
    "ccsj": "เวลาถือ",
    "zy": "ทำกำไร",
    "zs": "หยุดการสูญเสีย",
    "zje": "ยอดรวม",
    "kcs": "จำนวนตำแหน่งที่เปิดรับ",
    "kcjg": "ราคาเปิด",
    "ss": "ล็อต",
    "hand": "1 ล็อต =",
    "qx": "ยกเลิก",
    "qr": "ยืนยัน",
    "qbcd":"ยกเลิกคำสั่งซื้อทั้งหมด"
  },
  "kxt": {
    "gao":"H",
    "di":"L",
    "wtgd": "มอบหมายที่รอดำเนินการ",
    "cj": "ดีล",
    "jj": "บทนำ",
    "sj": "เวลา",
    "fx": "ทิศทาง",
    "jg": "ราคา",
    "sl": "ปริมาณ",
    "mr": "ซื้อเข้า",
    "mc": "ขายออก",
    "mp": "คำสั่งซื้อ",
    "sp": "คำสั่งขาย",
    "slb": "ปริมาณ",
    "fhsj": "เวลาเปิดขาย",
    "fhsl": "จำนวนเปิดขาย",
    "bps": "กระดาษสีขาว",
    "gw": "เว็บไซต์อย่างเป็นทางการ",
    "fz":"min",
    "xs":"hour",
    "tian":"day",
    "zhou":"week",
    "yue":"month",
    "gd": "More",
    "ft": "ภาพรอง",
    "zt": "ภาพหลัก",
    "sdt": "แผนที่ความลึก",
    "zx": "เลือกเอง",
    "djck": "คลิกเพื่อดู"
  },
  "zhjl": {
    "cbtb": "ฝากและถอน",
    "jymx": "รายละเอียดการทำธุรกรรม",
    "tgyj": "ค่าคอมมิชชั่นโปรโมชั่น",
    "wwc": "ยังไม่สำเร็จ",
    "ywc": "สำเร็จ"
  },
  "zwsj": {
    "title": "ไม่มีข้อมูล"
  },
  "bzxz": {
    "title": "เลือกสกุลเงิน"
  },
  "jghy": {
    "jghy": "อนาคต",
    "yxhy": "ถาวร",
    "mz": "ขาขึ้น",
    "md": "ขาลง",
    "gmj": "ราคาซื้อ",
    "jsj": "ราคาชำระ",
    "xj": "ราคาปัจจุบัน",
    "fx": "ทิศทาง",
    "sl": "ปริมาณ",
    "jgsj": "เวลาจัดส่ง",
    "gb": "ปิดตัวลง",
    "jxxd": "สั่งซื้อต่อ",
    "cclb": "รายชื่อตำแหน่ง",
    "zc": "ถืออยู่",
    "lscc": "ประวัติการถือ",
    "qblx": "ทุกประเภท",
    "yk": "กำไรขาดทุน",
    "ddqr": "ยืนยันการสั่งซื้อ",
    "dqsj": "วันที่ครบอายุ",
    "jssj": "เวลาตัดบัญชี",
    "sy": "รายได้",
    "tzje": "จำนวนเงินลงทุน",
    "zdje": "จำนวนเงินลงทุนมากกว่า 0",
    "kyye": "สมดุล: ",
    "kyye2": "สมดุล",
    "sxf": "ค่าธรรมเนียม: ",
    "sxfl": "ค่าธรรมเนียม",
    "jypz": "ประเภทการซื้อขาย",
    "jyfx": "ทิศทางการซื้อขาย",
    "qrxd": "ยืนยันสั่งซื้อ",
    "fs": "more",
    "dqye": "ยอดคงเหลือ"
  },
  "kjmb": {
    "title": "สกุลเงินดิจิตอล",
    "gm": "ซื้อ USDT",
    "wxts": "เคล็ดลับ:",
    "copy": "คัดลอก",
    "ljmb": "ซื้อสกุลเงินดิจิทัล",
    "qx": "ยกเลิก",
    "gmsl": "ปริมาณซื้อ",
    "cssl": "ปริมาณขาย",
    "qsrgmsl": "โปรดใส่จำนวนที่สั่งซื้อ",
    "qsrcssl": "โปรดใส่จำนวนที่ขาย",
    "jg": "ราคา",
    "fzcg": "คัดลอกสำเร็จ"
  },
  "tips": {
    "jymm": "รหัสผ่านการทำธุรกรรม",
    "szjymm": "ตั้งรหัสผ่านการทำธุรกรรม",
    "qsrjymm": "โปรดใส่รหัสผ่านการทำธุรกรรม",
    "jymmts": "โปรดไปที่ศูนย์ความปลอดภัยเพื่อตั้งรหัสผ่านการทำธุรกรรม"
  },
  "xyf":{
    "title": "คะแนนเครดิต",
    "pgsj": "เวลาประเมิน"
  },
  "dzrz":{
    "title": "การตรวจสอบที่อยู่",
    "sdddz":"ที่อยู่บิลค่าสาธารณูปโภค",
    "tpsc": "บิลอิมเมจอัพโหลด",
    "ts": "คำเตือน: คุณต้องกรอกข้อมูลที่อยู่และส่งบิลค่าสาธารณูปโภคหรือค่าที่อยู่บรอดแบนด์",
    "tips":"คุณต้องกรอกข้อมูลที่อยู่และส่งบิลค่าสาธารณูปโภคหรือค่าที่อยู่บรอดแบนด์",
    "qsczdtp":"บิลอิมเมจอัพโหลด"
  },
  "newReg":{
    "sjh": "โทรศัพท์มือถือ",
    "yx": "อีเมล",
    "yqm": "รหัสการเชิญ",
    "yqm2": "รหัสเชิญ (ไม่บังคับ)",
    "cjzh": "สร้างบัญชี",
    "sysjhzyx": "ลงทะเบียนด้วยเบอร์มือถือ/อีเมล",
    "sj": "มือถือ",
    "yhxy": "&lt;ข้อตกลงผู้ใช้&gt;",
    "yhxy2": "ฉันได้อ่านและยอมรับและ &lt;ข้อตกลงผู้ใช้&gt; "
  },
  "mbwt":{
    "title": "การตั้งค่าคำถามความปลอดภัยลับ",
    "mbwt": "คำถามเพื่อความปลอดภัย",
    "qtxda": "โปรดใส่คำตอบ",
    "qsrxmm": "กรุณาใส่รหัสผ่านใหม่",
    "sydqmmcz": "ใช้รหัสผ่านปัจจุบันในการรีเซ็ต",
    "zhmm": "ปัญหาด้านความปลอดภัย เรียกรหัสผ่าน",
    "ysz": "ตั้งค่าแล้ว",
    "tg": "ข้าม",
    "tj": "ส่ง",
    "zyts": "สำคัญ:",
    "zytsCont": "อย่าเปิดเผยคำตอบลับและรหัสยืนยัน และคำนึงถึงปัญหาด้านความปลอดภัยซึ่งจะช่วยให้คุณดึงรหัสผ่านของคุณ"
  },
  "xbsg":{
    "title": "ซนเหรียญใหม่",
    "wdsg": "รายละเอียด",
    "scts": "วันกักตัว: ",
    "sy": "ที่เหลืออยู่",
    "ljsg": "สมัครสมาชิกตอนนี้",
    "ysk": "ขายหมดแล้ว",
    "xzjdy": "สมัครสมาชิกตอนนี้",
    "dy": "ติดตาม",
    "fxjg": "ออกราคา",
    "fxl": "การไหลเวียน",
    "ssrq": "วันที่ลงรายการ",
    "yxqx": "ระยะเวลาที่ใช้ได้",
    "qsrsl": "กรุณาระบุจำนวนเงิน",
    "syl": "ที่เหลืออยู่",
    "sgrq": "ติดตาม",
    "sgsl": "จำนวน",
    "bz": "เหรียญ",
    "yebz": "ยอดเงิน USDT ไม่เพียงพอ",
    "tgsl": "ผ่านจำนวน",
    "shz": "ภายใต้การทบทวน",
    "wtg": "ไม่ผ่าน",
    "ytg": "ผ่านไป"
  },
  "wydb":{
    "title": "ยืม",
    "db": "ยืม",
    "dbz": "ยืม",
    "jl": "บันทึก",
    "jdzq": "ระยะเวลา (วัน)",
    "qhk": "เพื่อชำระคืน",
    "ljdb": "สะสม(usdt)",
    "dhkbs" :"ที่รอดำเนินการชำระเงิน",
    "jkje": "วงเงินกู้(usdt)",
    "qsrje": "กรุณาระบุจำนวนเงิน",
    "rll": "อัตราดอกเบี้ยรายวัน",
    "hkfs": "การชำระคืน",
    "dqych": "หมดอายุ",
    "lx": "ความสนใจ",
    "fkjg": "ผู้ให้กู้",
    "tpsc": "สินเชื่อเงินกู้ (อัพโหลดรูปภาพ)",
    "fwxx": "ข้อมูลที่อยู่อาศัย",
    "srzm": "หลักฐานแสดงรายได้ (ความสัมพันธ์ในการจ้างงาน)",
    "yhmx": "รายการเงินฝากถอนในบัญชีเงินฝาก",
    "zjz": "รูปถ่ายประจำตัว",
    "yd": "ฉันได้อ่านและตกลง",
    "xy": "สมัครสัญญาเงินกู้",
    "sqdb": "สมัครกลุ่มสินเชื่อ",
    "gb": "ปิด",
    "qd": "ตกลง",
    "ts": "โปรดตรวจสอบ สมัครสัญญาเงินกู้",
    "dbjl": "บันทึก",
    "hkhth": "รหัสการสั่งซื้อ",
    "wsh": "ยังไม่ได้ตรวจสอบ",
    "yfk": "เงินกู้",
    "sqrq": "เวลาสมัคร",
    "zq": "วงจร",
    "dbsl": "จำนวนซี่โครง",
    "zhke": "การชำระเงินทั้งหมด",
    "yhkxq": "รายละเอียดการชำระคืน",
    "bqyhk": "ชำระคืนในงวดปัจจุบัน(USDT)",
    "hktips": "กรุณาตรวจสอบให้แน่ใจว่ายอดเงินคงเหลือเพียงพอ หากยอดเงินไม่เพียงพอ กรุณาเติมเงินก่อนแล้วจึงค่อยชำระคืน",
    "bj": "อาจารย์ใหญ่",
    "jie": "ยืม",
    "ljhk": "ชำระคืนทันที",
    "qcz": "การฝาก",
    "yebzqxcz": "ยอดเงินไม่เพียงพอ กรุณาเติมเงินก่อนแล้วค่อยชำระคืน",
    "znj": "ค่าธรรมเนียมการชำระล่าช้า",
    "yqts": "วันที่เกินกำหนด"
  },
  "hkxq":{
    "dd":"คำสั่ง",
    "fzhkdz":"คัดลอกที่อยู่การชำระเงิน",
    "hkxq": "รายละเอียดการชำระคืน",
    "zlx": "ดอกเบี้ยทั้งหมด",
    "zhk": "ชำระคืนทั้งหมด",
    "hkjg": "หน่วยงานการชำระคืน",
    "hkpz": "ใบรับรองการชำระหนี้"
  },
  "bbjyNew":{
    "jylx": "ชนิดของ",
    "jyze": "จำนวน"
  },
  "indexNew":{
    "title": "เพิ่ม Spmaxex ไปที่อินเทอร์เฟซหลัก",
    "t1": "เข้าถึงประสบการณ์เต็มหน้าจออย่างรวดเร็ว",
    "t2": "คลิกที่แถบเครื่องมือด้านล่าง",
    "t3": "และเลือก",
    "t4": "พิ่มไปที่หน้าจอหลัก",
    "t5": "เพิ่มประสบการณ์ Spmaxex เวอร์ชันเต็มบนเดสก์ท็อป",
    "t6": "เพิ่มในรายการโปรด",
    "t7": "ค้นหาในเพจ"
  },
  "bind":{
    "title": "การตรวจสอบอีเมล",
    "ybd": "ผูกพัน",
    "wbd": "หลุด",
    "yrz": "ตรวจสอบแล้ว",
    "wrz": "ไม่ได้รับการยืนยัน",
    "ts": "เพื่อปกป้องบัญชีของคุณ ขอแนะนำให้ผูกที่อยู่อีเมล",
    "qsryxdz": "ที่อยู่อีเมล"
  },
  "status":{
    "statusText": ['ความล้มเหลว','รอดำเนินการ','ความสำเร็จ'],
 },
 "tipsNew":{
   "wjmmts": "กู้คืนรหัสผ่านด้วยรหัสยืนยัน",
   "qscpztp": "อัพโหลดภาพบัตรกำนัล",
   "emailgsts": "กรุณาใส่อีเมลที่ถูกต้อง",
   "telgsts": "หมายเลขโทรศัพท์มือถือไม่ถูกต้อง",
   "lcmmbyz": "กรุณายืนยันรหัสผ่านของคุณ",
   "zdsl": "จำนวนขั้นต่ำ ",
   "sldydy": "ปริมาณที่มากกว่าหรือเท่ากับ",
   "zxtzsl": "จำนวนขั้นต่ำ ",
   "ddz": "ที่รอ",
   "xs": "ชั่วโมง",
   "min": "จำนวนขั้นต่ำ ",
   "max": "จำนวนสูงสุด ",
   "yebz": "ยอดเงินไม่เพียงพอ",
   "qsrss": "กรุณาใส่ล็อต",
   "zdss": "ล็อตขั้นต่ำ",
   "yjj": "ถูกปฏิเสธ",
   "shz": "การไถ่ถอน",
   "zwkfcz": "สกุลเงินนี้ยังไม่เปิดให้เติมเงิน",
   "jiaoge": "เดลิเวอรี่",
    "zhang": "ซื้อ",
    "die": "ขาย",
    "cjxnzh": "สร้างบัญชีเสมือน"
 },
 "langNew2":{
  "flzq": "ศูนย์กลางของรางวัล",
  "qdjl": "รางวัลเข้าสู่ระบบ",
  "mrqdjl": "รางวัลลงชื่อเข้าใช้รายวัน",
  "qd": "เข้าสู่ระบบ",
  "yqd": "ลงทะเบียนเข้า",
  "hdgz": "กฎของกิจกรรม",
  "qdjl2": "บันทึกการเช็คอิน",
  "qdcg": "ลงชื่อเข้าใช้สำเร็จ",
  "yhd": "ได้มา",
  "lq": "รับ",
  "dyt": "วันที่ 1",
  "det": "วันที่ 2",
  "dst": "วันที่ 3",
  "dsit": "วันที่ 4",
  "dwt": "วันที่ 5",
  "dlt": "วันที่ 6",
  "dqt": "วันที่ 7",
  "jxz": "กำลังดำเนินการ"
},
"langNew":{
  "kp": "เปิด",
  "zuoshou": "ได้รับเมื่อวาน",
  "zg": "สูงสุด",
  "zd": "ต่ำสุด",
  "dqjg": "ราคาปัจจุบัน",
  "pcjg": "ราคาปิด",
  "gd": "คำสั่งซื้อที่รอดำเนินการ",
  "gdj": "ราคาคำสั่งซื้อที่รอดำเนินการ",
  "gdjg": "ราคาคำสั่งซื้อที่รอดำเนินการ",
  "xfbzj": "เงินประกันที่จำเป็น: ",
  "ksrfw": "ช่วงอินพุตที่ใช้ได้: ",
  "shou": "จำนวนมาก",
  "fdjyk": "กำไรสุทธิลอยตัว",
  "pcsl": "ปริมาณการปิดบัญชี",
  "cx": "ถอน",
  "qrpc": "ยืนยันการปิดตำแหน่ง",
  "sx": "กรอง",
  "cz": "รีเซ็ต",
  "zdl": "รู้",
  "kccg": "เปิดตำแหน่งสำเร็จ!",
  "xzfx": "เลือกทิศทาง",
  "lx": "พิมพ",
  "xgcc": "แก้ไขตำแหน่ง",
  "szzyzs": "ตั้งค่าหยุดกำไรและหยุดการขาดทุน",
  "szhb": "สกุลเงินดิจิทัล",
  "gjs": "โลหะ",
  "yy": "น้ำมันดิบ",
  "jy": "ซื้อขาย",
  "jmhb": "สกุลเงินดิจิทัล",
  "gdsj": "เวลาการสั่งซื้อที่รอดำเนินการ",
  "gdsl": "จำนวนการสั่งซื้อที่รอดำเนินการ",
  "fs": "time",
  "qbdl": "เข้าสู่ระบบกระเป๋าเงิน",
  "qbdlts": "โปรดใช้เบราว์เซอร์กระเป๋าเงินเพื่อเข้าถึงและเข้าสู่ระบบ",
  "tcmnzh": "ออกจากระบบบัญชีเสมือน",
  "bc": "ตำแหน่งฝาครอบ",
  "qdlzszh":"กรุณาเข้าสู่บัญชีจริงของคุณเพื่อเติมเงิน",
  "ts": "พรอมต์",
  "czsqytj": "ส่งใบสมัครเติมเงินแล้ว",
  "czdzts": "ส่งใบสมัครเติมเงินแล้ว แต่ยังไม่ได้รับการเติมเงิน?",
  "fhsy": "กลับไปที่หน้าแรก",
  "je": "จำนวน",
  "zdje": "จำนวนเงินขั้นต่ำ ",
  "zdje2": "จำนวนเงินสูงสุด "
 }
}



// WEBPACK FOOTER //
// ./src/utils/lang/th.js